import { Injectable } from "@angular/core";
import { BackendService } from "../backend/backend.service";

@Injectable({
  providedIn: "root"
})
export class CandidateListService {
  private path = "/candidates";

  constructor(private backendService: BackendService) {}

  searchCandidates(currPage: number, pageSize: number, filter: any) {
    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter
    };

    return this.backendService.post(this.path + "/search", data);
  }

  searchTestCenters(filter: any) {
    var data = {
      filter: filter
    };
    return this.backendService.post(this.path + "/centers/search", data);
  }

  getCandidatesById(id) {
    return this.backendService.get(this.path + "/" + id + "/candidates");
  }


  getCandidateBatches(id) {
    return this.backendService.get(this.path + "/" + id + "/batches");
  }

   getVerificationMetricData(id, metric_type, batchid) {
    return this.backendService.get(this.path + "/" + id + "/verification/" + metric_type  +"/batch/" + batchid);
  }


  saveTestCenters(id, testcenter) {
    var data = {
      candidate_id: id,
      testcenter: testcenter
    };
    return this.backendService.post(this.path + "/centers", data);
  }

  deleteAll (){
    return  this.backendService.get(this.path + "/deleteall");
  }


  candidateError (){
    return  this.backendService.get(this.path + "/errors");
  }
}
